<template>
	<div>
		<datetime
			v-model="context.model"
			class="datepicker"
			:phrases="{ ok: 'Choisir', cancel: 'Annuler' }"
		></datetime>
	</div>
</template>

<script>
export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="scss">
.datepicker input {
	cursor: pointer;
}
</style>